import create from 'zustand';
import produce from 'immer';

import { initializeApp } from "firebase/app"
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { getFirestore, collection, doc, onSnapshot } from "firebase/firestore";
import { request, auth } from '../libs/utils';
import VoxeetSDK from '@voxeet/voxeet-web-sdk';



const useUserStore = create((set, get) => {
    return {
        firstName: '',
        lastName: '',
        isLoggedIn: !!auth.currentUser(),
        id: '',
        auth,
        ...(auth.currentUser() || {}),
        name: auth.currentUser() && `${auth.currentUser().firstName} ${auth.currentUser().lastName}`,
        load: () => {
            if(!auth.currentUser()) return null;
            const user = auth.currentUser();
            const userData = {
                firstName: user.firstName,
                lastName: user.lastName,
                name: `${user.firstName} ${user.lastName}`,
                officeId: user.officeId,
                isLoggedIn: true,
                id: user.id,
            };
            set(userData);
            return userData;
        },
        login: async (firstName, lastName) => {
            if(!firstName || !lastName) throw new Error('First name and Last name required');
            const user = auth.login(firstName, lastName);
            set({
                firstName: user.firstName,
                lastName: user.lastName,
                name: `${user.firstName} ${user.lastName}`,
                officeId: user.officeId,
                isLoggedIn: true,
                id: user.id,
            })
        },
        getFB: async () => {
            const config = await (await request(`/api/common/fb/config`)).json();
            initializeApp(config);
            const { token } = await (await request(`/api/common/fb/token`)).json();
            const auth = getAuth();
            await signInWithCustomToken(auth, token);
        },
        initiateDolby: async () => {
            const { firstName, lastName, id: userId } = auth.currentUser() || {};
            const { token } = await (await request('/api/common/token', 'GET')).json();
            VoxeetSDK.initializeToken(token, async () => {
                const { token } = await (await request('/api/common/token', 'GET')).json();
                return token;
            });
            await VoxeetSDK.session.open({ name: `${firstName} ${lastName}`, externalId: userId });
        },
        setOfficeId: async (officeId) => {
            auth.currentUser().update({
                officeId
            });
            set(produce(state => {
                state.officeId = officeId;
            }));
        },
        logout: () => {
            auth.logout();
            set({
                id: null,
                firstName: null,
                lastName: null,
            })
        }
    }
});

export { useUserStore };